(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["novo-pdp-intro"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-intro-more]');
    if (!button) return;
    const root = button.closest('[data-intro]');
    const short = root.querySelector('.novo-pdp-intro__short');
    const full = root.querySelector('.novo-pdp-intro__full');
    const open = button.getAttribute('aria-expanded') !== 'true';
    short.hidden = open;
    full.hidden = !open;
    full.classList.toggle('is-in', open);
    button.setAttribute('aria-expanded', String(open));
    button.textContent = open ? button.dataset.less : button.dataset.more;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ss-pdp-info"] && !Shopify.designMode) return;
  try {
    /* Softstead: the dimension drawings come on (near-)white. The white is made truly transparent in a canvas, so the
     drawing sits on the theme colour on every device; mobile browsers did not always honour mix-blend-mode. If the
     image cannot be read (CORS, error), the CSS blend stays as the fallback. */
  (() => {
    const process = (img) => {
      if (img.dataset.ssClear || !img.complete || !img.naturalWidth) return;
      img.dataset.ssClear = 'busy';
      const source = new Image();
      source.crossOrigin = 'anonymous';
      source.onload = () => {
        try {
          const scale = Math.min(1, 1400 / source.naturalWidth);
          const w = Math.round(source.naturalWidth * scale);
          const h = Math.round(source.naturalHeight * scale);
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(source, 0, 0, w, h);
          const data = ctx.getImageData(0, 0, w, h);
          const px = data.data;
          for (let i = 0; i < px.length; i += 4) {
            const light = Math.min(px[i], px[i + 1], px[i + 2]);
            // 236 and lighter: fully transparent; 206–236: fade, so anti-aliased edges stay smooth.
            if (light >= 236) px[i + 3] = 0;
            else if (light > 206) px[i + 3] = Math.round((px[i + 3] * (236 - light)) / 30);
          }
          ctx.putImageData(data, 0, 0);
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = canvas.toDataURL('image/png');
          img.dataset.ssClear = 'done';
        } catch (error) {
          img.dataset.ssClear = 'failed';
        }
      };
      source.onerror = () => {
        img.dataset.ssClear = 'failed';
      };
      source.src = img.currentSrc || img.src;
    };
    const run = () => {
      document.querySelectorAll('.ss-pdp-info__media img:not([data-ss-clear])').forEach((img) => {
        if (img.complete) process(img);
        else img.addEventListener('load', () => process(img), { once: true });
      });
    };
    run();
    document.addEventListener('DOMContentLoaded', run);
    // Lazy drawings load when their row opens; catch every load, whenever it happens.
    document.addEventListener(
      'load',
      (event) => {
        const img = event.target;
        if (img instanceof HTMLImageElement && img.closest('.ss-pdp-info__media') && img.dataset.ssClear !== 'done') {
          if (img.dataset.ssClear === 'busy') return;
          delete img.dataset.ssClear;
          process(img);
        }
      },
      true
    );
    // Accordion rows and Horizon re-renders (variant change) bring new images.
    document.addEventListener('toggle', run, true);
    document.addEventListener('shopify:section:load', run);
  })();

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-info-zoom]');
    if (!trigger) return;
    let dialog = document.querySelector('.ss-pdp-zoom');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'ss-pdp-zoom';
      dialog.innerHTML =
        '<img alt="">' +
        '<button type="button" class="ss-pdp-zoom__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg>' +
        '</button>';
      // Any click inside (image, close button or the backdrop) closes it.
      dialog.addEventListener('click', () => dialog.close());
      document.body.appendChild(dialog);
    }
    const img = dialog.querySelector('img');
    // Use the drawing whose white was made transparent, when ready; else the large original.
    const small = trigger.querySelector('img');
    img.src = small && small.dataset.ssClear === 'done' ? small.src : trigger.dataset.infoZoom;
    img.alt = trigger.querySelector('img')?.alt || '';
    dialog.showModal();
  });
  } catch(e) { console.error(e); }
})();

})();
